import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "standard-section" }
const _hoisted_2 = { class: "item-ul" }
const _hoisted_3 = { class: "item-name" }
const _hoisted_4 = { class: "category-ul" }
const _hoisted_5 = { class: "category-name" }
const _hoisted_6 = { class: "detail-ul" }
const _hoisted_7 = {
  key: 0,
  class: "detail-desc"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, itemIndex) => {
        return (_openBlock(), _createBlock("li", {
          class: "item-li",
          key: item.itemName + itemIndex
        }, [
          _createVNode("h2", _hoisted_3, _toDisplayString(item.itemName), 1),
          _createVNode("ul", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.itemList, (category, categoryIndex) => {
              return (_openBlock(), _createBlock("li", {
                class: "category-li",
                key: category.categoryName + categoryIndex
              }, [
                _createVNode("h3", _hoisted_5, _toDisplayString(category.categoryName), 1),
                _createVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.categoryList, (detail, detailIndex) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "detail-li",
                      key: detail.detailName + detailIndex
                    }, [
                      (detail.detailName)
                        ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(detail.detailName) + ":  " + _toDisplayString(detail.detailDesc), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}